"use strict";

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.autocapitalize = void 0;

var autocapitalize = function autocapitalize(value, rule) {
  if (!value) {
    return value;
  }

  if (rule === 'off' || rule === 'none' || !rule) {
    return value;
  }

  if (rule === 'on' || rule === 'sentences') {
    if (value.includes('.') || value.includes('?') || value.includes('!')) {
      var returnValue = '';
      value.split(/([.?!] )/g).forEach(function (item) {
        returnValue += item ? "".concat(item[0].toUpperCase()).concat(item.substring(1)) : '';
      });
      return returnValue;
    }

    return "".concat(value[0].toUpperCase()).concat(value.substring(1));
  }

  if (rule === 'words') {
    var _returnValue = '';
    value.split(/([ -])/g).forEach(function (item) {
      _returnValue += item ? "".concat(item[0].toUpperCase()).concat(item.substring(1)) : '';
    });
    return _returnValue;
  }

  if (rule === 'characters') {
    return value.toUpperCase();
  }

  return value;
};

exports.autocapitalize = autocapitalize;